import React from 'react';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';
import locales from '../../locales/LocalesManager';
import mouseUtils from '../../components/utils/MouseUtils';
import { changeDrawingProperties } from '../../actions/MenuActions';
import modeType from '../../constants/ModeConstants';
import drawingUtils from '../utils/DrawingUtils';
import { OnOffToggleButton } from './OnOffToggleButton';
import appParameters from '../../components/utils/AppParameters';
import platformDetection from '../utils/PlatformDetection';

const Title = React.createClass({
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        var title;

        if (this.props.contextMode == modeType.FREEHAND_CONTEXT)
            title = locales.getCaption('freehand', 'drawing');
        else
            title = locales.getCaption('line', 'drawing');

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{title}</span>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: { // Cancel
                drawingUtils.executeAction('cancel');
                break;
            }

            case 1: { // OK
                drawingUtils.executeAction('ok');
                break;
            }
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.windowHeight != newProps.windowHeight)
            return true;
        else
            return false;
    },
    render() {
        var textColor;
        var buttonColor;

        if (this.props.index == 1) {
            if (this.state.isOver == true) {
                textColor = properties.CONTEXT_HOVER_COLOR;
                buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
            } else {
                textColor = 'black';
                buttonColor = '#48A5E5';
            }
        } else {
            if (this.state.isOver == true) {
                textColor = properties.CONTEXT_HOVER_COLOR;
                buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
            } else {
                textColor = 'black';
                buttonColor = '#DCDCDC';
            }
        }

        var buttonWidth = this.props.accordionWidth;
        var buttonHeight = 50;

        var buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: buttonWidth,
            height: buttonHeight,
            display: 'flex',
            alignItems: 'center',
            left: 0,
            top: this.props.windowHeight - (this.props.index + 1) * (buttonHeight + 5),
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            borderStyle: 'none'
        };

        const spanStyle = {
            color: textColor,
            fontSize: 18,
            position: 'absolute',
            width: buttonWidth,
            cursor: 'default',
            textAlign: 'center',
            top: 14
        };

        var idValue = this.props.index == 1 ? 'firstFocusableObject' : 'drawingFreehandLastFocusableElement';

        return (
            <button id={idValue} aria-label={this.props.text} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

const Element = React.createClass({
    getInitialState() {
        return{
            isOver: false
        };
    },
    getStrokeWidth() {
        var strokeWidth = 3;

        switch(this.props.index) {
            case 0: {
                strokeWidth = 11;
                break;
            }
            case 1: {
                strokeWidth = 9;
                break;
            }
            case 2: {
                strokeWidth = 7;
                break;
            }
            case 3: {
                strokeWidth = 5;
                break;
            }
            case 4: {
                strokeWidth = 3;
                break;
            }
        }

        return strokeWidth;
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.index < 5)
            this.props.dispatch(changeDrawingProperties('strokeWidth', this.getStrokeWidth()));
        else
            this.props.dispatch(changeDrawingProperties('strokeColor', this.props.fillColor));
    },
    isSelected() {
        var drawingProperties = drawingUtils.getDrawingProperties();

        if (this.props.index < 5) {
            var strokeWidth = this.getStrokeWidth();

            if (drawingProperties.strokeWidth == strokeWidth)
                return true;
            else
                return false;
        } else {
            if (this.props.fillColor == drawingProperties.strokeColor)
                return true;
            else
                return false;
        }
    },
    onMouseIn() {
        this.setState({
            isOver: true
        });
    },
    onMouseOut() {
        this.setState({
            isOver: false
        });
    },
    render() {
        var opacity = 1;

        if (this.state.isOver)
            opacity = 0.5;

        var color = this.props.borderColor;
        var borderSize = this.props.borderSize;

        if (this.isSelected()) {
            color = properties.CONTEXT_HOVER_COLOR;
            borderSize = 4;
        }

        const elementStyle = {
            position: 'absolute',
            width: this.props.radius * 2,
            height: this.props.radius * 2,
            background: this.props.fillColor,
            borderColor: color,
            borderWidth: borderSize,
            borderStyle: 'solid',
            borderRadius: 50,
            left: this.props.centerX - this.props.radius,
            top: this.props.centerY - this.props.radius,
            opacity,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
        };

        var ariaLabel = '';

        if (this.props.index < 5)
            ariaLabel = locales.getCaption('changeLineSize', 'other');
        else
            ariaLabel = locales.getCaption('changeLineColor', 'other');

        return (
            <button aria-label={ariaLabel} style={elementStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
            </button>
        );
    }
});

export const DrawingMenu = React.createClass({
    componentDidMount() {
        drawingUtils.dispatch = this.props.dispatch;

        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('firstFocusableObject');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        setTimeout(this.updateView, 10);
    },
    updateView() {
        const state = storeManager.getState();
        const contextMode = state.menu.contextMode;

        if (contextMode == modeType.FREEHAND_CONTEXT || contextMode == modeType.LINE_CONTEXT)
            this.forceUpdate();
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        var radiusSize = [];
        var startRadius = 28;
        var radiusOffset = 4;
        var i;
        var xPositions = [];
        var leftPos = 63;
        var leftPosForFill = 80;
        var gap = 10;
        var gapColor = 25;

        if (platformDetection.isIOS()) {
            startRadius = 24;
            leftPos = 30;
            gap = 8;
            leftPosForFill = 37;
        }

        var currentX = leftPos;
        var radius = startRadius;

        for (i=0; i<5; i++) {
            xPositions.push(currentX);
            radiusSize.push(radius);

            currentX = currentX + 2 * radius + gap;
            radius = radius - radiusOffset;
        }

        var onOffButtonProperties = {};

        onOffButtonProperties.leftPosition = properties.MY_MEDIA_FILES_GAP;
        onOffButtonProperties.trackWidth = properties.TOGGLE_TRACK_WIDTH;
        onOffButtonProperties.trackHeight = properties.TOGGLE_TRACK_HEIGHT;
        onOffButtonProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
        onOffButtonProperties.thumbSize = properties.TOGGLE_THUMB_SIZE;
        onOffButtonProperties.dispatch = this.props.dispatch;
        onOffButtonProperties.width = properties.BROWSER_WIDTH - 2 * properties.MY_MEDIA_FILES_GAP;
        onOffButtonProperties.topPosition = properties.CLIPART_BUTTON_HEIGHT + 20;

        onOffButtonProperties.isDrawing = true;
        onOffButtonProperties.groupDrawingShapes = this.props.groupDrawingShapes;


        var brushStyle = {
            position: 'absolute',
            top: onOffButtonProperties.topPosition + 40,
            left: this.props.accordionWidth / 2 - 15,
            color: 'black'
        };

        var pencilStyle = {
            position: 'absolute',
            top: 420,
            left: this.props.accordionWidth / 2 - 15,
            color: 'black'
        };

        var strokeSizeTopPosition = 510;
        var offsetY = 0;
        var offsetY2 = 0;
        var offsetY3 = 0;


        if (strokeSizeTopPosition + radiusSize[0] > this.props.windowHeight - 2 * 55 - 10) {
            brushStyle.top = brushStyle.top - 15;
            pencilStyle.top = pencilStyle.top - 80;
            offsetY = 30;
            offsetY2 = 40;
            offsetY3 = 90;
        }

        return (
            <div style={menuStyle} onTouchEnd={this.onClick} onClick={this.onClick} id="drawingMenu">
                <Title accordionWidth={this.props.accordionWidth} contextMode={this.props.contextMode}/>
                <OnOffToggleButton id="firstFocusableElement" properties={onOffButtonProperties} dispatch={this.props.dispatch}/>

                <i style={brushStyle} className="fa fa-tint fa-3x"></i>
                <i style={pencilStyle} className="fa fa-pencil fa-3x"></i>

                <Element index={5} radius={startRadius} fillColor={'#3F53AA'} borderColor={'#3F53AA'} borderSize={2} centerX={leftPosForFill} centerY={190 - offsetY} dispatch={this.props.dispatch}/>
                <Element index={6} radius={startRadius} fillColor={'#EA4033'} borderColor={'#EA4033'} borderSize={2} centerX={leftPosForFill + 2 * startRadius + gapColor} centerY={190 - offsetY} dispatch={this.props.dispatch}/>
                <Element index={7} radius={startRadius} fillColor={'#FFFFFF'} borderColor={'#868686'} borderSize={2} centerX={leftPosForFill + 4 * startRadius + 2 * gapColor} centerY={190 - offsetY} dispatch={this.props.dispatch}/>

                <Element index={8} radius={startRadius} fillColor={'#5DB547'} borderColor={'#5DB547'} borderSize={2} centerX={leftPosForFill} centerY={270 - offsetY2} dispatch={this.props.dispatch}/>
                <Element index={9} radius={startRadius} fillColor={'#F08734'} borderColor={'#F08734'} borderSize={2} centerX={leftPosForFill + 2 * startRadius + gapColor} centerY={270 - offsetY2} dispatch={this.props.dispatch}/>
                <Element index={10} radius={startRadius} fillColor={'#868686'} borderColor={'#868686'} borderSize={2} centerX={leftPosForFill + 4 * startRadius + 2 * gapColor} centerY={270 - offsetY2} dispatch={this.props.dispatch}/>

                <Element index={11} radius={startRadius} fillColor={'#F1F12D'} borderColor={'#F1F12D'} borderSize={2} centerX={leftPosForFill} centerY={340 - offsetY2} dispatch={this.props.dispatch}/>
                <Element index={12} radius={startRadius} fillColor={'#8B3492'} borderColor={'#8B3492'} borderSize={2} centerX={leftPosForFill + 2 * startRadius + gapColor} centerY={340 - offsetY2} dispatch={this.props.dispatch}/>
                <Element index={13} radius={startRadius} fillColor={'black'} borderColor={'#010101'} borderSize={2} centerX={leftPosForFill + 4 * startRadius + 2 * gapColor} centerY={340 - offsetY2} dispatch={this.props.dispatch}/>

                <Element index={0} radius={radiusSize[0]} fillColor={'black'} borderColor={'black'} borderSize={2} centerX={xPositions[0]} centerY={strokeSizeTopPosition - offsetY3} dispatch={this.props.dispatch}/>
                <Element index={1} radius={radiusSize[1]} fillColor={'black'} borderColor={'black'} borderSize={2} centerX={xPositions[1]} centerY={strokeSizeTopPosition - offsetY3} dispatch={this.props.dispatch}/>
                <Element index={2} radius={radiusSize[2]} fillColor={'black'} borderColor={'black'} borderSize={2} centerX={xPositions[2]} centerY={strokeSizeTopPosition - offsetY3} dispatch={this.props.dispatch}/>
                <Element index={3} radius={radiusSize[3]} fillColor={'black'} borderColor={'black'} borderSize={2} centerX={xPositions[3]} centerY={strokeSizeTopPosition - offsetY3} dispatch={this.props.dispatch}/>
                <Element index={4} radius={radiusSize[4]} fillColor={'black'} borderColor={'black'} borderSize={2} centerX={xPositions[4]} centerY={strokeSizeTopPosition - offsetY3} dispatch={this.props.dispatch}/>

                <Button index={1} text={locales.getCaption('DrawingOk', 'other')} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight}/>
                <Button index={0} text={locales.getCaption('Cancel', 'save')} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight}/>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/DrawingMenu.js
 **/